import Button from '@/components/Button/Button';
import NavArrowDownIcon from '@/assets/nav-arrow-down.svg';
import { styled } from '@mui/material/styles';

const MenuLink = ({
  children,
  onClick,
  active = false,
  arrow = false,
  dense = false,
  'aria-label': ariaLabel,
  'aria-expanded': ariaExpanded,
  'aria-haspopup': ariaHaspopup,
}: {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  active?: boolean;
  arrow?: boolean;
  dense?: boolean;
  'aria-label': string;
  'aria-expanded'?: boolean;
  'aria-haspopup'?: boolean;
}) => {
  return (
    <StyledButton
      onClick={onClick}
      active={active}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHaspopup}
    >
      <Label dense={dense}>{children}</Label>
      {arrow ? (
        <ArrowDown src={NavArrowDownIcon} dense={dense} />
      ) : null}
    </StyledButton>
  );
};

const StyledButton = styled(Button, {
  shouldForwardProp: (prop: string) => prop !== 'active',
})<{ active?: boolean; dense?: boolean }>(({ active, dense }) => ({
  fontWeight: 600,
  fontSize: '16px',
  letterSpacing: '0%',
  textAlign: 'center',
  verticalAlign: 'middle',
  textTransform: 'none',
  color: active ? '#BF1220 !important' : '#131927',
  gap: dense ? 0 : undefined,
}));

const Label = styled('div')<{ dense?: boolean }>(
  ({ theme, dense }) => ({
    minHeight: 24,
    lineHeight: '24px',
    padding: dense ? 0 : `0 ${theme.spacing(1)}`,
    display: 'flex',
    alignItems: 'center',
  }),
);

const ArrowDown = styled('img')<{ dense?: boolean }>(
  ({ theme, dense }) => ({
    marginLeft: dense ? 0 : theme.spacing(1),
  }),
);

export default MenuLink;
